import { createReducer } from '@reduxjs/toolkit';

import { Nullable } from 'modules/types/common';

import { switchAccountSuccess } from 'store/account/actions';

import * as actions from './actions';
import { MicrobiologyResult, ShareMicrobiologyResults } from '../types';

// *****************************
// ** Microbiology HISTORICAL **
// *****************************

export interface MicrobiologyHistoricalState {
  isFetching: boolean;
  data: MicrobiologyResult[] | null;
  error: Nullable<Error>;
}

export const microbiologyHistoricalInitialState = (): MicrobiologyHistoricalState => ({
  isFetching: false,
  data: null,
  error: null
});

export const microbiologyHistoricalReducer = createReducer(microbiologyHistoricalInitialState(), {
  [actions.GET_MICROBIOLOGY_HISTORICAL]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.GET_MICROBIOLOGY_HISTORICAL_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.GET_MICROBIOLOGY_HISTORICAL_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = action.payload.data.results || action.payload.data;
  },
  [switchAccountSuccess.type]: () => microbiologyHistoricalInitialState()
});

// ***********************************
// ** Download Microbiology Results **
// ***********************************

type MicrobiologyDetailsDownloadStatus = 'pending' | 'success' | 'fail';

export interface MicrobiologyDetailsDownloadsState {
  isDownloadingMicrobiologyDetails: boolean;
  data: Record<string, MicrobiologyDetailsDownloadStatus>;
}

export const microbiologyDetailsDownloadsInitialState = (): MicrobiologyDetailsDownloadsState => ({
  isDownloadingMicrobiologyDetails: false,
  data: {}
});

export const microbiologyDetailsDownloadsReducer = createReducer(
  microbiologyDetailsDownloadsInitialState(),
  {
    [actions.DOWNLOAD_MICROBIOLOGY_DETAILS]: (state, action) => {
      state.isDownloadingMicrobiologyDetails = true;
      state.data[action.payload.id] = 'pending';
    },
    [actions.DOWNLOAD_MICROBIOLOGY_DETAILS_SUCCESS]: (state, action) => {
      state.isDownloadingMicrobiologyDetails = false;
      state.data[action.payload.id] = 'success';
    },
    [actions.DOWNLOAD_MICROBIOLOGY_DETAILS_FAIL]: (state, action) => {
      state.isDownloadingMicrobiologyDetails = false;
      state.data[action.payload.id] = 'fail';
    }
  }
);

// ********************************
// ** Share Microbiology Results **
// ********************************

export interface ShareMicrobiologyResultsState {
  isSendingMicrobiologyResults: boolean;
  sharedMicrobiologyResultsData: ShareMicrobiologyResults | {};
  sharedMicrobiologyResultsError: Nullable<Error>;
}

export const shareMicrobiologyResultsInitialState = (): ShareMicrobiologyResultsState => ({
  isSendingMicrobiologyResults: false,
  sharedMicrobiologyResultsData: {},
  sharedMicrobiologyResultsError: null
});

export const shareMicrobiologyResultsReducer = createReducer(
  shareMicrobiologyResultsInitialState(),
  {
    [actions.SHARE_MICROBIOLOGY_RESULTS]: state => {
      state.isSendingMicrobiologyResults = true;
      state.sharedMicrobiologyResultsError = null;
    },
    [actions.SHARE_MICROBIOLOGY_RESULTS_SUCCESS]: (state, action) => {
      state.isSendingMicrobiologyResults = false;
      state.sharedMicrobiologyResultsData = action.payload.data;
    },
    [actions.SHARE_MICROBIOLOGY_RESULTS_FAIL]: (state, action) => {
      state.isSendingMicrobiologyResults = false;
      state.sharedMicrobiologyResultsError = action.error;
    }
  }
);
